import { Component } from '@angular/core';

@Component({
    selector: 'currency-peso-svg',
    templateUrl: './currency-peso.component.svg',
})
export class CurrencyPesoComponent { }
